"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CUSTOM_PROPERTY_NAME = '--aspect-ratio';
var DEFAULT_CLASS_NAME = 'react-aspect-ratio-placeholder';

var AspectRatio = function AspectRatio(props) {
  var _extends2;

  var children = props.children,
      ratio = props.ratio,
      style = props.style,
      restProps = _objectWithoutPropertiesLoose(props, ["children", "ratio", "style"]); // eslint-disable-line no-unused-vars


  var newStyle = _extends({}, style, (_extends2 = {}, _extends2[CUSTOM_PROPERTY_NAME] = "(" + ratio + ")", _extends2));

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, restProps, {
    style: newStyle
  }), children);
};

AspectRatio.defaultProps = {
  className: DEFAULT_CLASS_NAME,
  ratio: 1
};
var _default = AspectRatio;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-aspect-ratio/dist/react-latest.js
// module id = 774
// module chunks = 0